// extracted by mini-css-extract-plugin
module.exports = {"filterTag":"style_filterTag__keJR6","textWrapper":"style_textWrapper__iuGum","closeMarkSpan":"style_closeMarkSpan__pH6C5","color":"style_color__Lclos"};